import { render, staticRenderFns } from "./gant-header.vue?vue&type=template&id=79c53e8b&scoped=true"
import script from "./gant-header.vue?vue&type=script&lang=js"
export * from "./gant-header.vue?vue&type=script&lang=js"
import style0 from "./gant-header.vue?vue&type=style&index=0&id=79c53e8b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c53e8b",
  null
  
)

export default component.exports